export default "__VITE_ASSET__FICK1Xla__"